import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as faHeartSolid } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import { usePost } from '../../Api';
import { useNotification } from '../../Components/GlobalNotification';

import './style.css';

const FavoriteButton = ({ listingId, isInitiallyFavorited = false, className = '' }) => {
  const { showNotification } = useNotification();
  const [isFavorited, setIsFavorited] = useState(isInitiallyFavorited);
  const [isLoading, setIsLoading] = useState(false);
  const { ApiData: FavoriteResponse, loading: FavoriteLoading, error: FavoriteError, post: ToggleFavorite } = usePost(`/add-favorite/${listingId}`);

  // Check if user is logged in
  const isLoggedIn = localStorage.getItem('login') !== null;

  // Handle favorite toggle
  const handleFavoriteToggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Check if user is logged in
    if (!isLoggedIn) {
      showNotification({ type: 'error', title: 'Error', message: 'Please login to add favorites' });
      return;
    }

    if (isLoading) return;

    setIsLoading(true);
    try {
      await ToggleFavorite({});
    } catch (error) {
      console.error('Error toggling favorite:', error);
      showNotification({ type: 'error', title: 'Error', message: 'Failed to update favorite status' });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle API response
  useEffect(() => {
    if (FavoriteResponse) {
      const message = FavoriteResponse?.message || '';
      
      if (message.includes('added to favorites') || message.includes('Listing added to favorites')) {
        setIsFavorited(true);
        showNotification({ type: 'success', title: 'Success', message: 'Added to favorites' });
      } else if (message.includes('removed from favorites') || message.includes('Listing removed from favorites')) {
        setIsFavorited(false);
        showNotification({ type: 'success', title: 'Success', message: 'Removed from favorites' });
      } else {
        // Toggle current state if message doesn't match expected patterns
        setIsFavorited(prev => !prev);
      }
    }
  }, [FavoriteResponse]);

  // Handle API errors
  useEffect(() => {
    if (FavoriteError) {
      showNotification({ type: 'error', title: 'Error', message: FavoriteError?.message || 'Failed to update favorite status' });
    }
  }, [FavoriteError]);

  return (
    <button
      className={`favorite-button ${className} ${isLoading ? 'loading' : ''}`}
      onClick={handleFavoriteToggle}
      disabled={isLoading}
      title={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
    >
      <FontAwesomeIcon 
        icon={isFavorited ? faHeartSolid : faHeartRegular} 
        className={isFavorited ? 'text-danger' : 'text-dark'}
      />
    </button>
  );
};

export default FavoriteButton;
